import { z } from 'zod';

/** Forma unica degli errori API. */
export const ApiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
  request_id: z.string().optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

/** Il tetto mensile di spesa del motore AI (dell'azienda o della piattaforma): si riparte alzandolo, non riprovando. */
export const isBudgetError = (error: string | null | undefined): boolean => !!error && /tetto mensile di spesa/i.test(error);

/**
 * L'errore dice che il motore AI non poteva rispondere in quel momento (ADR 0151): credito o quota finiti, chiave
 * rifiutata o mancante, rete, tempo, sovraccarico, risposta interrotta. Non è un difetto del lavoro: il passo si rifà da
 * solo appena un motore risponde. Il tetto di spesa non è tra questi.
 */
export function isEngineUnavailable(error: string | null | undefined): boolean {
  if (!error || isBudgetError(error)) return false;
  return /non ha risposto in tempo|errore di rete verso il modello|ha risposto con errore (?:40[1-389]|429|5\d\d)|non ha completato la risposta|si è interrotta|risposta del modello vuota|in pausa|non configurat|non è configurato|quota|billing|credit|balance|insufficient|overload|rate limit/i.test(
    error,
  );
}

/** Il credito finito presso i fornitori, già detto in italiano dal motore di riserva (ADR 0148). */
export const isCreditMessage = (error: string | null | undefined): boolean => !!error && /^Il motore AI è senza credito/.test(error);

/** Ogni quanto si riprova da solo un passo fermo per il motore AI spento (ADR 0151). */
export const ENGINE_RETRY_MS = 2 * 60_000;

/**
 * L'errore nelle parole del titolare (ADR 0151): il testo tecnico del fornitore resta nei log. Gli errori già scritti
 * per le persone (in italiano, senza il modello) passano come sono.
 */
export function ownerError(error: string): string {
  // Già scritti per il titolare: il tetto di spesa e il credito finito presso i fornitori (ADR 0148), con la data.
  if (isBudgetError(error) || isCreditMessage(error)) return error;
  if (isEngineUnavailable(error)) return 'Il motore AI non ha potuto lavorare in quel momento. Rifaccio il passo da solo fra poco.';
  if (/modell|model|JSON|LLM|API/i.test(error)) return 'Il consulente non è riuscito a completare questo passo. Puoi rifarlo con il pulsante qui sotto.';
  return error;
}
